import { DefaultJobAd, JobAd } from '../../Models/JobAd';
import { defaultJobAdFormValues, type JobAdFormValues } from './JobAdStep.schema';
import JobAdSkillsType from '@/Models/JobAdSkillsType';
import autoMapping from '@/Utils/autoMapping';

export enum JobAdFieldTypes {
    Title = 'title',
    HardSkills = 'hardSkills',
    HardSkillsSwitch = 'hardSkillsSwitch',
    SoftSkills = 'softSkills',
    SoftSkillsSwitch = 'softSkillsSwitch',
    Description = 'description',
    DescriptionLen = 'descriptionLen',
    CompanyDescription = 'companyDescription',
}

export function jobAdModel2FormValues(model: JobAd): JobAdFormValues {
    return autoMapping(model, defaultJobAdFormValues);
}

export function jobAdFormValues2Model(values: JobAdFormValues): JobAd {
    return autoMapping(values, DefaultJobAd);
}

export function getAutocompleteSkillsType(type: JobAdSkillsType): JobAdFieldTypes {
    switch (type) {
        case JobAdSkillsType.HardSkill:
            return JobAdFieldTypes.HardSkills;
        case JobAdSkillsType.SoftSkill:
            return JobAdFieldTypes.SoftSkills;
        default:
            throw new Error('invalid skills type');
    }
}

export function fillInInitialSkills(
    initialFormValues: JobAdFormValues,
    existingFormValues: JobAdFormValues,
): JobAdFormValues {
    // we always take skills from existing form values
    // because user can edit those during job ad generation
    return {
        ...initialFormValues,
        hardSkills: existingFormValues.hardSkills,
        softSkills: existingFormValues.softSkills,
        hardSkillsSwitch: existingFormValues.hardSkillsSwitch,
        softSkillsSwitch: existingFormValues.softSkillsSwitch,
    };
}

export function getSkillsSwitchName(type: JobAdSkillsType): JobAdFieldTypes {
    switch (type) {
        case JobAdSkillsType.HardSkill:
            return JobAdFieldTypes.HardSkillsSwitch;
        case JobAdSkillsType.SoftSkill:
            return JobAdFieldTypes.SoftSkillsSwitch;
        default:
            throw new Error('invalid skills type');
    }
}
